import { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import TrixEditor from "components/FormElements/Fields/TrixTextAreaField/TrixEditor";

const SAVE_DEBOUNCE_MS = 800;

interface Props {
  value: string | null;
  placeholder: string;
  onChange: (nextValue: string) => void;
}

// Wraps TrixEditor's react-hook-form dependency so callers get plain value/onChange with debounced saves.
export default function AutosaveTrixField({ value, placeholder, onChange }: Props) {
  const { control } = useForm<{ content: string }>({
    values: { content: value ?? "" },
  });
  const content = useWatch({ control, name: "content" }) ?? "";
  // Trix serializes an empty document to "" — same emptiness check TrixEditor uses.
  const normalized = content.trim() === "" ? "" : content;

  useEffect(() => {
    if (normalized === (value ?? "")) return undefined;
    const timer = setTimeout(() => onChange(normalized), SAVE_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [normalized]); // eslint-disable-line react-hooks/exhaustive-deps

  return <TrixEditor name="content" control={control} placeholder={placeholder} includeAttachment={false} includeInlineImage />;
}
